export const UI_ICON_MAPPING = [
  // MD3 UI icons
  { id: "info", path: "info" },
  { id: "more_vert", path: "more_vert" },
  { id: "add_link", path: "add_link" },
  { id: "link_off", path: "link_off" },
  { id: "link", path: "link" },
  { id: "sync", path: "sync" },
  { id: "sync_disabled", path: "sync_disabled" },
  { id: "groups", path: "library_books" },
  { id: "edit", path: "edit" },
  { id: "edit_off", path: "edit_off" },
  { id: "track", path: "route" },
  { id: "tracks", path: "network_node" },
  { id: "star", path: "star" },
  { id: "star_added", path: "star_added" },
  { id: "bookmark", path: "bookmark" },
  { id: "bookmark_added", path: "bookmark_added" },
  { id: "splitscreen", path: "splitscreen" },
  { id: "splitscreen_portrait", path: "splitscreen_portrait" },
  { id: "splitscreen_bottom", path: "splitscreen_bottom" },
  { id: "swap_horizontal", path: "swap_horiz" },
  { id: "history", path: "view_timeline" },
  { id: "add_stack", path: "note_stack_add" },
  { id: "stack_star", path: "stack_star" },
  { id: "stack", path: "stack" },
  { id: "search", path: "search" },
  { id: "add", path: "add_2" },
  { id: "add_circle", path: "add_circle" },
  { id: "area_chart", path: "area_chart" },
  { id: "arrow_back", path: "arrow_back" },
  { id: "arrow_downward", path: "arrow_downward" },
  { id: "arrow_forward", path: "arrow_forward" },
  { id: "arrow_upward", path: "arrow_upward" },
  { id: "check", path: "check" },
  { id: "cancel", path: "cancel" },
  { id: "select_all", path: "select_all" },
  { id: "select_check_box", path: "select_check_box" },
  { id: "check_box", path: "check_box" },
  { id: "check_box_outline_blank", path: "check_box_outline_blank" },
  { id: "close", path: "close" },
  { id: "close_small", path: "close_small" },
  { id: "dark_mode", path: "dark_mode" },
  { id: "delete", path: "delete" },
  { id: "description", path: "description" },
  { id: "filter_list", path: "filter_list" },
  { id: "filter_list_off", path: "filter_list_off" },
  { id: "fit_tracks", path: "fit_tracks" },
  { id: "fit_track", path: "fit_track" },
  { id: "folder", path: "folder" },
  { id: "folder_open", path: "folder_open" },
  { id: "keyboard_arrow_down", path: "keyboard_arrow_down" },
  { id: "keyboard_arrow_left", path: "keyboard_arrow_left" },
  { id: "keyboard_arrow_right", path: "keyboard_arrow_right" },
  { id: "keyboard_arrow_up", path: "keyboard_arrow_up" },
  { id: "language", path: "language" },
  { id: "laps", path: "laps" },
  { id: "layers", path: "layers" },
  { id: "location_disabled", path: "location_disabled" },
  { id: "location_on", path: "location_on" },
  { id: "location_searching", path: "location_searching" },
  { id: "manage_accounts", path: "manage_accounts" },
  { id: "my_location", path: "my_location" },
  { id: "radio_button_checked", path: "radio_button_checked" },
  { id: "radio_button_unchecked", path: "radio_button_unchecked" },
  { id: "settings", path: "settings" },
  { id: "sort", path: "sort" },
  { id: "unfold_less", path: "unfold_less" },
  { id: "unfold_more", path: "unfold_more" },
  { id: "upload", path: "upload" },
  { id: "visibility", path: "visibility" },
  { id: "visibility_off", path: "visibility_off" },
  { id: "question_mark", path: "question_mark" },
  { id: "drop_down", path: "arrow_drop_down" },
  { id: "drop_up", path: "arrow_drop_up" },
  { id: "error", path: "error" },
];

export const resolveUIIcon = (symbol) => {
  if (!symbol) return "";
  const mapping = UI_ICON_MAPPING.find((item) => item.id === symbol);

  if (mapping) {
    try {
      return require("../../../svg/ui/icons/" + mapping.path + ".svg");
    } catch (e) {
      console.warn("Trackalyze UI icon not found:", symbol);
      return "";
    }
  }
  return null; // Return null if it's not a UI icon
};
